import React from "react";
import { Navegacao } from "../components/navegacao/BottomNavegation";
import styles from "./Layout.module.scss";
import { MainHeader } from "shared/components/headers/MainHeader";
import { useLocation, Outlet } from "react-router-dom";
import { Carregamento } from "shared/components/carregamento/Carregamento";
import { DivPerfil } from "shared/components/divperfil/DivPerfil";
import { NavLojista } from "../components/navLojista/NavLojista";

interface LayoutProps {
  hasNavegation?: boolean;
  loading?: boolean;
}

const Layout: React.FC<LayoutProps> = ({
  hasNavegation = true,
  loading = false,
}) => {
  const location = useLocation();

  /* ================================
     PATH NORMALIZADO
  ================================ */

  const currentPath =
    location.pathname === "/"
      ? "/"
      : location.pathname.toLowerCase().replace(/\/$/, "");

  /* ================================
     ROTAS
  ================================ */

  const hideNavegationOn = [
    "/minhaconta/cadastroproduto",
    "/minhaloja",
    "/cadastroloja/etapa",
    "/cadastroproduto",
    "/arealojista",
    "/cuponsdescontos",
    "/loja",
  ];

  const showNavLojistaOn = [
    "/arealojista/metricas",
    "/arealojista/perfillojista",
    "/arealojista/lojas",
    "/arealojista/produtos",
    "/arealojista/clientes",
    "/arealojista/vendas",
    "/arealojista/entregas",
    "/arealojista/dadosbancarios",
    "/arealojista/configuracoes",
  ];

  const showMainHeaderOn = [
    "/",
    "/login",
    "/senhaenviada",
    "/cadastrosucesso",
  ];

  const showDivPerfilOn = [
    "/meuperfil",
  ];

  // Vitrine pública da loja (/lojas/:id): tela de cliente, igual à Home.
  // Precisa de exceção porque "/loja" em hideNavegationOn também casa
  // com "/lojas" pelo startsWith.
  const isVitrineLoja = currentPath.startsWith("/lojas/");

  /* ================================
     CONTROLES
  ================================ */

  const showNavegation =
    hasNavegation &&
    !loading &&
    (isVitrineLoja ||
      !hideNavegationOn.some((path) =>
        currentPath.startsWith(path)
      ));

  const showMainHeader =
    showMainHeaderOn.includes(currentPath) || isVitrineLoja;

  const showDivPerfil =
    showDivPerfilOn.includes(currentPath) &&
    !currentPath.startsWith(
      "/minhaconta/cadastroproduto"
    );

  const showNavLojista =
    showNavLojistaOn.some((path) =>
      currentPath.startsWith(path)
    );

  /* ================================
     RENDER
  ================================ */

  return (
    <div className={styles.page}>

      {/* ================================
          HEADER PRINCIPAL
      ================================ */}

      {showMainHeader && <MainHeader />}

      {/* ================================
          PERFIL
      ================================ */}

      {showDivPerfil && <DivPerfil />}

      {/* ================================
          NAVEGAÇÃO LOJISTA
      ================================ */}

      {showNavLojista && <NavLojista />}

      {/* ================================
          CONTEÚDO
      ================================ */}

      {loading ? (
        <Carregamento />
      ) : (
        <>
          <div
            className={`${styles.content} ${
              showNavegation
                ? styles.withBottomNav
                : styles.noBottomNav
            }`}
          >
            <Outlet />
          </div>

          {/* ================================
              NAVEGAÇÃO MOBILE
          ================================ */}

          {showNavegation && <Navegacao />}
        </>
      )}
    </div>
  );
};

export default Layout;